import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LoaderService {
	// isLoading = new Subject<boolean>();
	loadingSub$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	loading: boolean = false;
	loadingMap: Map<string, boolean> = new Map<string, boolean>();
	constructor() {}

	show() {
		this.loading = true;
		this.loadingSub$.next(true);
	}

	hide() {
		this.loading = false;
		this.loadingSub$.next(false);
	}
}
